import { Button, Gapped, Modal, Toast } from "react-ui";
import * as React from "react";

import { useMetrics } from "../../../../Internals/Metrics/MetricsProviderContext";
import { ACCEPT_CONVERT_CLICK } from "../../../../metricsAction";

import { ModalContent } from "./ConvertDraftModal.styles";

interface ConvertDraftModalProps {
    onClose: () => void;
    onConvertDraftFromPrevGfv: () => Promise<void>;
    transferText?: string;
}

export const ConvertDraftModal = (props: ConvertDraftModalProps) => {
    const track = useMetrics();

    const handleAcceptConvertModal = async (): Promise<void> => {
        track(ACCEPT_CONVERT_CLICK);
        try {
            await props.onConvertDraftFromPrevGfv();
        } catch {
            Toast.push("Не удалось перенести данные. Попробуйте позже.");
        } finally {
            props.onClose();
        }
    };

    return (
        <Modal ignoreBackgroundClick onClose={props.onClose}>
            <Modal.Header>Перенос данных</Modal.Header>
            <Modal.Body>
                <ModalContent>
                    {props.transferText ?? "Вы можете перенести данные из формы предыдущего формата"}
                </ModalContent>
            </Modal.Body>
            <Modal.Footer>
                <Gapped gap={8}>
                    <Button use="primary" size="medium" onClick={handleAcceptConvertModal}>
                        Перенести данные
                    </Button>
                    <Button size="medium" onClick={props.onClose}>
                        Отменить
                    </Button>
                </Gapped>
            </Modal.Footer>
        </Modal>
    );
};
